<template>
  <div class="paper-student-preview">
    <div class="header">
      <el-radio-group v-model="current">
        <el-radio-button label="has-match">条件内符合的学生</el-radio-button>
        <el-radio-button label="not-match">条件内不符合的学生</el-radio-button>
      </el-radio-group>
    </div>
    <div class="main">
      <div class="main-cont">
        <keep-alive>
          <component :is="previewComponent" :grid-params="condition"></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import PaperStudentPreviewHasMatch from './has-match'
import PaperStudentPreviewNotMatch from './not-match'
export default {
  name: 'PaperStudentPreview',
  components: {
    PaperStudentPreviewHasMatch,
    PaperStudentPreviewNotMatch
  },
  props: {
    condition: {
      type: Object
    }
  },
  data () {
    return {
      current: 'has-match'
    }
  },
  computed: {
    previewComponent () {
      switch (this.current) {
        case 'has-match':
          return 'PaperStudentPreviewHasMatch'
        case 'not-match':
          return 'PaperStudentPreviewNotMatch'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.paper-student-preview {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;

  & > .header {
    flex: none;
    text-align: center;
    padding: 0 15px 10px;
    background-color: #f3f4f5;

    .el-radio-group {
      white-space: nowrap;

      .el-radio-button {
        & > .el-radio-button__inner {
          min-width: 190px;
          padding: 6px 10px;
          border-radius: 0;
        }
      }
    }
  }

  & > .main {
    flex: auto;
    position: relative;
    background-color: #fff;

    & > .main-cont {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
